import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableSortIconComponent } from './table-sort-icon.component';

@NgModule({
    declarations: [TableSortIconComponent],
    exports: [TableSortIconComponent],
    imports: [
        CommonModule,
        FontAwesomeModule,
    ],
})
export class TableSortIconModule {}
